import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { WebsitePrimaryButton, TertiaryButton } from '@dev/ee-components';
import { CancelEditStep, getLandingPageCreatorStore, SaveStart } from '@/store/landingPageCreator/actions';
import { LandingPageCreatorStatus } from '@/store/landingPageCreator/types';
import { StepContentProps } from './types';
import { StepContentFooter, StepContentWrapper } from './styles';

export const StepContent = ({
    content,
    editContent,
    isEditMode,
    isNew,
    isSaveVisible,
    isSaveDisabled,
    onSave
}: StepContentProps): JSX.Element => { 
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { status } = useSelector(getLandingPageCreatorStore);

    const onCancelEdit = (): void => {
        dispatch(CancelEditStep());
    };

    const onSaveEdit = (): void => {
        // if (beforeSave && !includes(landingPagePayload?.FormSettings, FormSettingsEnum.AddDoubleOptIn) && !includes(landingPagePayload?.FormSettings, FormSettingsEnum.DoubleOptInDisabled)) {
        //     const formSettings = landingPagePayload?.FormSettings ?? landingPageObject?.FormSettings ?? [];
        //     const newSettings = uniq([...formSettings, FormSettingsEnum.AddDoubleOptIn]);
        //     dispatch(ModifyLandingPage({FormSettings: newSettings}))
        // }

        //for custom action on step save
        if(!!onSave){
             onSave();
            return;
        }

        // if (beforeSave && !landingPagePayload?.FormPageType) {
        //     dispatch(ModifyLandingPage({FormPageType: [...landingPageObject?.FormPageType || []]}))
        // }
        dispatch(SaveStart({}));
    };

    const isSaving = status === LandingPageCreatorStatus.SAVING;
    const isContinueDisabled = isSaveDisabled || isSaving;

    if (isEditMode && isNew) {
        return(
            <StepContentWrapper>
                {editContent}
                {isSaveVisible && (
                        <StepContentFooter>
                            <WebsitePrimaryButton text={t('continue')} disabled={isContinueDisabled} onClick={onSaveEdit} isLoading={isSaving} />
                        </StepContentFooter>
                    )
                }
            </StepContentWrapper>
        );
    }
    
    if (isEditMode) {
        return(
            <StepContentWrapper>
                {editContent}
                <StepContentFooter>
                    <TertiaryButton onClick={onCancelEdit} text={t('cancel')} />
                    {isSaveVisible && <WebsitePrimaryButton text={t('save')} disabled={isContinueDisabled} onClick={onSaveEdit} isLoading={isSaving} />}
                </StepContentFooter>
            </StepContentWrapper>
        );
    }

    return(
        <StepContentWrapper>{content}</StepContentWrapper>
    );
};
